import React, { useState } from 'react';
import { SideBarModal } from '@/components/Modal';
import { Button } from '@/components';
import { Repossession } from '@/types/common';

interface InvestigationPopUpProps {
  isOpen: boolean;
  repoCase: Repossession | null;
  onClose: () => void;
  onSubmit: (reason: string) => void;
  isSubmitting?: boolean;
}

const InvestigationPopUp: React.FC<InvestigationPopUpProps> = ({
  isOpen,
  repoCase,
  onClose,
  onSubmit,
  isSubmitting = false,
}) => {
  const [reason, setReason] = useState('');

  const handleClose = () => {
    setReason('');
    onClose();
  };

  const handleSubmit = () => {
    onSubmit(reason.trim());
  };

  return (
    <SideBarModal
      isOpen={isOpen}
      onClose={handleClose}
      position="right"
      width="sm"
      maxHeight="screen"
      header={
        <div>
          <div className="text-base font-semibold text-gray-900">
            Start Investigation
          </div>
          <div className="text-xs text-gray-500">
            Update case status to begin field operations.
          </div>
        </div>
      }
      footer={
        <div className="flex w-full justify-end">
          <Button
            onClick={handleSubmit}
            disabled={isSubmitting}
            className="w-full"
            variant={'primary'}
          >
            {isSubmitting ? 'Saving...' : 'Save'}
          </Button>
        </div>
      }
      className="max-w-[400px]"
    >
      <div className="bg-gray-50 px-4 py-2 text-[12px] font-medium text-gray-500 rounded-md">
        Detail
      </div>
      <div className="px-6 py-4">
        <div className="space-y-4">
          <div>
            <label className="block text-xs font-medium text-gray-500 mb-1">
              Current Status
            </label>
            <div className="relative">
              <input
                value={repoCase?.status || ''}
                disabled
                className="w-full rounded-md border border-gray-200 bg-gray-50 px-3 py-2 text-sm text-gray-400"
              />
              <span className="pointer-events-none absolute inset-y-0 right-3 flex items-center text-gray-300">
                <i className="ri-arrow-down-s-line" />
              </span>
            </div>
          </div>

          <div>
            <label className="block text-xs font-medium text-gray-500 mb-1">
              Change Status to<span className="text-red-500"> *</span>
            </label>
            <div className="relative">
              <input
                value="IN PROGRESS"
                disabled
                className="w-full rounded-md border border-gray-200 bg-gray-50 px-3 py-2 text-sm text-gray-400"
              />
              <span className="pointer-events-none absolute inset-y-0 right-3 flex items-center text-gray-300">
                <i className="ri-arrow-down-s-line" />
              </span>
            </div>
          </div>

          <div>
            <label className="block text-xs font-medium text-gray-500 mb-1">
              Reason for Changing Status (optional)
            </label>
            <div className="relative">
              <textarea
                value={reason}
                onChange={(e) => setReason(e.target.value)}
                placeholder="Optional: Jelaskan kenapa merubah status"
                rows={4}
                className="w-full rounded-md border border-blue-200 px-3 py-2 text-sm text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-200"
              />
              <div className="absolute bottom-2 right-3 text-[10px] text-gray-400">
                {Math.min(reason.length, 200)}/200
              </div>
            </div>
          </div>
        </div>
      </div>
    </SideBarModal>
  );
};

export default InvestigationPopUp;
